import { useMemo } from 'react';

import { Dashboard, Fact, FactType } from '@/api/rest/resources/conservation';

import { useConservationFile } from './useConservation';
import { useConservationProjectName } from './useConservationProjectName';

const useDashboardFactsByType = () => {
  const projectName = useConservationProjectName();

  if (!projectName) {
    throw new Error('Conservation project name not found');
  }

  const dashboardData = useConservationFile<Dashboard>({
    projectName,
    fileName: 'dashboard.json',
  });

  return (dashboardData?.facts.reduce((acc, curr) => {
    return {
      ...acc,
      [curr.name]: curr,
    };
  }, {}) ?? {}) as Record<FactType, Fact>;
};

export const useFact = <V, F extends FactType = FactType>(factType: F) => {
  const dashboardFacts = useDashboardFactsByType();

  return useMemo(() => {
    // eslint-disable-next-line security/detect-object-injection
    return dashboardFacts[factType] as Fact<F, V>;
  }, [dashboardFacts, factType]);
};
